import { render, staticRenderFns } from "./payFee.vue?vue&type=template&id=3ca5746c&scoped=true&"
import script from "./payFee.vue?vue&type=script&lang=js&"
export * from "./payFee.vue?vue&type=script&lang=js&"
import style0 from "./payFee.vue?vue&type=style&index=0&id=3ca5746c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca5746c",
  null
  
)

export default component.exports